import { useSuspenseQuery } from '@tanstack/react-query';

import { getCourseValidationHistoryOptions } from '@/module/Author/Course/Validation/model/CourseValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface CourseValidationHistoryProps {
  courseId: Id;
}

export function CourseValidationHistory({ courseId }: CourseValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getCourseValidationHistoryOptions(courseId));

  return <ValidationHistoryContent history={history} />;
}
